module.exports = __webpack_public_path__ + "media/images/willcoates-nav-logo-efa278ff7c6e269118eeb2277a9b98c9.svg";